/**
 * Força da senha por heurística local (sem dicionário nem dependência): comprimento manda, a
 * variedade de tipos de caractere ajuda e a repetição derruba. É orientação para quem digita —
 * quem decide se a senha é aceita é o `senhaSchema` do contrato (mínimo de 12 caracteres).
 */
export const MINIMO_SENHA = 12;

export type NivelForcaSenha = 0 | 1 | 2 | 3 | 4;

export interface ForcaSenha {
  /** 0 = vazia; 1 Fraca, 2 Razoável, 3 Boa, 4 Forte. */
  nivel: NivelForcaSenha;
  rotulo: '' | 'Fraca' | 'Razoável' | 'Boa' | 'Forte';
  /** Próximo passo em linguagem simples; vazio quando não há o que sugerir. */
  dica: string;
}

const CLASSES = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/];
/** Menos caracteres distintos que isso = repetição ("aaaa…", "123123…"). */
const MINIMO_DISTINTOS = 5;

const FRACA = (dica: string): ForcaSenha => ({ nivel: 1, rotulo: 'Fraca', dica });

function pontos(senha: string): number {
  const variedade = CLASSES.filter((classe) => classe.test(senha)).length - 1;
  const extensao = [16, 20, 24].filter((limite) => senha.length >= limite).length;
  return variedade + extensao;
}

export function avaliarForcaSenha(senha: string): ForcaSenha {
  if (senha === '') return { nivel: 0, rotulo: '', dica: '' };
  // Mesma conta do zod (`.min(12)` mede em unidades UTF-16): o medidor nunca diverge do contrato.
  const faltam = MINIMO_SENHA - senha.length;
  if (faltam > 0) return FRACA(faltam === 1 ? 'Falta 1 caractere' : `Faltam ${faltam} caracteres`);
  if (new Set(senha).size < MINIMO_DISTINTOS) return FRACA('Evite repetir os mesmos caracteres');
  const total = pontos(senha);
  if (total >= 4) return { nivel: 4, rotulo: 'Forte', dica: '' };
  if (total >= 2) return { nivel: 3, rotulo: 'Boa', dica: 'Uma frase mais longa a deixa forte' };
  return { nivel: 2, rotulo: 'Razoável', dica: 'Misture maiúsculas, números ou símbolos' };
}
